export const SkillsData = [
    {
        id: 1,
        skillsName: 'Illustration',
        skillsCount: '90%'
    },
    {
        id: 2,
        skillsName: 'Web desing',
        skillsCount: '80%'
    },
    {
        id: 3,
        skillsName: 'Develope',
        skillsCount: '90%'
    }
]